import React, { useState } from 'react';
import styled from 'styled-components';
import * as CTA from "../../../util/CTA";
import * as color from "../../../util/colors";
import { Text } from '../../../util/typography';
import { NAVIGATION_BREAKPOINT } from '../../../constants/layout';
import { Link } from 'gatsby';
import { multiTextUnderline } from '../../../util/typography/Text';
import { splitGradient } from '../../../util/CTA/PrimaryButton';
import { arrowRightWhite } from '../../../util/icons';

const bp = NAVIGATION_BREAKPOINT;

const UtilityBannerContainer = styled.div`
  display: flex;
  height: auto;
  // min-height: 40px;
  width: 100%;
  padding: 8px 20px;
  text-align: center;
  justify-content: center;
  background: ${(props)=>props.brandType === "keytrudahcp" ? "linear-gradient(106deg, #4A0075 1.28%, #5A008F 19.07%, #6A00A8 51.59%, #7C02BB 80.74%, #8215BA 99.08%)" : "linear-gradient(107deg, #2C6D3C 9%, #2C6D3C 44.13%, #36864A 98.1%)"};
  box-shadow: ${(props)=>props.brandType === "keytrudahcp" ? "0px 10px 20px 0px rgba(0, 0, 0, 0.16)" : "unset"};
  transition: background 0.3s ease-out, margin-top 0.3s ease-in-out;
  z-index: 0;
  pointer-events: auto !important;
  cursor: pointer;

  &:hover,
  &:active,
  &:focus {
      a span {
      background-image: linear-gradient(transparent, transparent), linear-gradient(${color.white}, ${color.white}) !important;
      // bottom: -2px !important;  
      background-size: 100% 1.1px !important;  
      &::before {
        transform: scaleX(0) !important;
        }        
      }   
    }

  @media (max-width: ${bp}) {
  padding: ${props => props.brandType === "keytrudahcp"  ? "10px" : "8px 20px"};
  }
`;

const StyledTertiaryButton = styled(CTA.TertiaryButton)`
  color: ${color.white};
  width: 100%;
  display: inline;
  justify-content: center;
  position: relative;
  padding-inline: 2px; 

  span {
    bottom: 0 !important;
  }

  &:hover,
  &:active,
  &:focus {
    color: ${color.white};
    &::after {        
      // background-image:none;
    }
    span{
    &::before {
    transform: scaleX(0);
      }
    }
  }

  span {
    padding: 0;
    font-weight: 600 !important;   
    ${multiTextUnderline};
    background-image: linear-gradient(transparent, transparent), linear-gradient(${color.white}, ${color.white});
    bottom: -2px;     
  }
  &::after {
    margin-bottom: -5px;
  }

  @media (max-width: 845px){
  &::after {
  // margin-bottom: -5px;
    }
  }

  
`;

const UtilityBanner = ({brandType="keytrudahcp",bannerText="KEYTRUDA QLEX™ (pembrolizumab + berahyaluronidase alfa-pmph) is FDA-approved. Learn more.", buttonURL="/qlex/"}) => {
  const [gradientPosition, setGradientPosition] = useState({ x: 100, y: 50 });
  const [isCardHovered, setCardHovered] = useState(false);
  const [recursiveRunning, setRecursiveRunning] = useState(false);

  const handleMouseEnter = () => {
    setCardHovered(true)
  }
    const handleMouseLeave = () => {
    setCardHovered(false)
  }

   const handleMouseMove = (e) => {
    e.stopPropagation();
    const rect = e.target.getBoundingClientRect();
    const x = Math.round(((e.clientX - rect.left) / rect.width) * 100);
    const y = ((e.clientY - rect.top) / rect.height) * 100;  

    if(!recursiveRunning){
      if(x > gradientPosition.x){
        recusrvieCalc(x,y,"increment",gradientPosition.x)
  
      }else{
        recusrvieCalc(x,y,"decrement",gradientPosition.x)
      }

    }
   
  }; 

  function recusrvieCalc(x,y,type,currentX){

    if(type == "increment"){
      setTimeout(()=>{

        const changedX = currentX + 1;
        setGradientPosition({
          x: changedX, // Convert mouse position to percentage of the width
          y: y, // Convert mouse position to percentage of the height
        });
        if(x !== currentX){
          setRecursiveRunning(true)
          recusrvieCalc(x,y,"increment",changedX)
        }else{
          setRecursiveRunning(false)
        }
      },0.3)
    }else{
      setTimeout(()=>{
      const changedX = currentX - 1;
      setGradientPosition({
        x: changedX,
        y: y, 
      });
      if(x !== currentX){
        setRecursiveRunning(true)
        recusrvieCalc(x,y,"decrement",changedX)
      }else{
        setRecursiveRunning(false)
      }
    },0.3)
    }
  }

  const gradientStyle = brandType === "keytrudahcp" ? {
    backgroundImage: `radial-gradient(circle at ${gradientPosition.x}% ${gradientPosition.y}%, #8215BA 0%, #7C02BB 40%, #6A00A8 60%, #5A008F 80%, #4A0075 100%)`,
    transition:"background 0.3s linear",
  } : {
    backgroundImage:`linear-gradient(107deg, #2C6D3C 9%, #2C6D3C 44.13%, #36864A 98.1%);`
  }

  return (
    <>
     <UtilityBannerContainer     
      style={gradientStyle}
      brandType={brandType}
      // onClick={()=> history.push('/qlex/')}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      {/* <PropagationCont /> */}
      <StyledTertiaryButton
        theme='light'
        onMouseMove={handleMouseMove}
        parentHovered = {isCardHovered}
        // onMouseEnter={handleMouseEnter}
        // onMouseLeave={handleMouseLeave}
        label={bannerText} url={buttonURL}>
      </StyledTertiaryButton>
      
    </UtilityBannerContainer>
    </>
  );
};

export default UtilityBanner;